





































































































import Vue from 'vue'
import { crawler } from '@rhitics/core'

export default Vue.extend({
  name: 'SearchReportPage',
  data() {
    return {
      valid: true,
      loading: true,
      menu: false,
      taskNames: [] as string[],
      taskName: '',
      dates: [] as string[]
    }
  },
  computed: {
    dateRangeText() {
      //@ts-ignore
      return this.dates.join(' ~ ')
    }
  },
  async mounted() {
    this.taskNames = (await crawler.searchRanking.list()).data
    this.loading = false
  },
  methods: {
    async downloadReport() {
      //@ts-ignore
      if (!this.$refs.form.validate()) return
      try {
        this.loading = true
        await crawler.searchRanking.download(this.taskName, this.dates[0], this.dates[1])
        this.$toast.success(`取得爬蟲報表成功，請於幾分鐘後前往信箱確認是否有成功收到報表，如果長時間未收到結果，請回報IT-Rhitics處理`)
      } catch (err: any) {
        alert('Sorry download data failed, please contact IT team.')
      } finally {
        this.loading = false
      }
    }
  }
})
